import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaDownload, FaExternalLinkAlt } from "react-icons/fa";

const DownloadScreen = () => {
  return (
    <Container className="py-5 my-5">
      <Row className="justify-content-center">
        <Col lg={10} xl={9}>
          {/* card--opaque: not clickable, so no hover grow (only the button is) */}
          <Card
            className="card--opaque shadow-lg border-0 rounded-4 overflow-hidden"
            style={{ minHeight: "450px" }}
          >
            <Row className="g-0 h-100">
              {/* Brand Column */}
              <Col
                md={4}
                className="bg-primary d-flex flex-column align-items-center justify-content-center text-white py-5 px-4 text-center"
              >
                <FaDownload size={80} className="mb-4" />
                <h1 className="fw-bold display-6 mb-0">Get JDiskMark</h1>
                <p className="mt-3 opacity-75 d-none d-md-block">
                  THE ULTIMATE STORAGE BENCHMARKING UTILITY
                </p>
              </Col>

              {/* Content Column */}
              <Col md={8}>
                <Card.Body className="p-5 h-100 d-flex flex-column justify-content-center">
                  {/* Inherits the theme's card text color (readable on light and dark cards) */}
                  <h2 className="mb-4 fw-bold display-6">
                    Take Control of Your Storage Performance Now
                  </h2>
                  <p className="text-muted mb-3 fs-5">
                    JDiskMark is a professional-grade tool for measuring 
                    and recording storage hardware input/output (I/O) throughput 
                    (rate of data flow) that's now available to 
                    the public.
                  </p>
                  <p className="text-muted mb-5 fs-5">
                    Download our FREE desktop application to start benchmarking 
                    your drives right away! Then, sign up to track and 
                    share your benchmarks with like-minded hardware 
                    performance enthusiasts and professionals today!
                  </p>
                  <div className="mt-auto">
                    <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center">
                      <Button
                        variant="primary"
                        size="lg"
                        className="rounded-pill py-3 px-5 m-auto fw-bold shadow-sm"
                        href="https://sourceforge.net/projects/jdiskmark/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Download from SourceForge{" "}
                        <FaExternalLinkAlt size={16} className="ms-2 mb-1" />
                      </Button>
                    </div>

                    <div className="mt-5 pt-4 border-top">
                      <p className="small text-muted mb-0 d-flex align-items-center gap-2">
                        <span
                          className="bg-success rounded-circle"
                          style={{ width: "12px", height: "12px" }}
                        ></span>
                        <b>Cross-platform compatible with Windows, macOS, and Linux!</b>
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DownloadScreen;